import produce from 'immer';
import { Reducer } from 'redux';

import actionTypes from 'store/actionTypes';
import {
  Action,
  ChecklistManagementState,
  ChecklistFolderListResponse,
} from 'models/index.m';
import { initialChecklistManagementStateData } from 'store/initialStateData';

type checklistAction = Action<
  ChecklistManagementState | ChecklistManagementState[] | null | boolean
>;

export const checklistReducer: Reducer<
  ChecklistManagementState,
  checklistAction
> = (
  checklistData = initialChecklistManagementStateData,
  action: checklistAction | null = null,
) => {
  if (!action) {
    return checklistData;
  }

  return produce(checklistData, (draft) => {
    switch (action.type) {
      case actionTypes.SET_CHECKLIST_FOLDER_LIST:
        // eslint-disable-next-line no-case-declarations
        const checklistData: any = action.payload;
        draft.checklistFolderData = <ChecklistFolderListResponse | null>(
          checklistData
        );
        break;
      case actionTypes.SET_CHECKLIST_FOLDER_IS_FETCHING:
        draft.isChecklistFolderFetching = <boolean>action.payload;
        break;
      case actionTypes.SET_CHECKLIST_FOLDER_IS_ADDING:
        draft.isChecklistFolderAdding = <boolean>action.payload;
        break;
      case actionTypes.SET_CHECKLIST_FOLDER_IS_REMOVING:
        draft.isChecklistFolderRemoving = <boolean>action.payload;
        break;
      case actionTypes.SET_CHECKLIST_FOLDER_IS_UPDATEING:
        draft.isChecklistFolderUpdateing = <boolean>action.payload;
        break;
      case actionTypes.SET_CHECKLIST_IS_ADDING:
        draft.isChecklistAdding = <boolean>action.payload;
        break;
      case actionTypes.SET_CHECKLIST_IS_REMOVING:
        draft.isChecklistRemoving = <boolean>action.payload;
        break;
      case actionTypes.SET_EXIST_CHECKLIST_ITEM_IS_ADDING:
        draft.isExistChecklistItemAdding = <boolean>action.payload;
        break;
      case actionTypes.SET_CHECKLIST_IS_UPDATING:
        draft.isChecklistUpdating = <boolean>action.payload;
        break;
      case actionTypes.SET_CHECKLIST_ITEM_IS_UPDATING:
        draft.isChecklistItemUpdateing = <boolean>action.payload;
        break;
      case actionTypes.IS_CHECKLIST_ITEM_ADDING_SUCCESS:
        draft.isChecklistItemAddSuccess = <boolean>action.payload;
        break;
      case actionTypes.IS_CHECKLIST_ITEM_UPDATING_SUCCESS:
        draft.isChecklistItemUpdateSuccess = <boolean>action.payload;
        break;
      case actionTypes.IS_CHECKLIST_ADDING_SUCCESS:
        draft.isChecklistAddSuccess = <boolean>action.payload;
        break;
      case actionTypes.IS_CHECKLIST_REMOVING_SUCCESS:
        draft.isChecklistRemoveSuccess = <boolean>action.payload;
        break;
      case actionTypes.IS_CHECKLIST_UPDATING_SUCCESS:
        draft.isChecklistUpdateSuccess = <boolean>action.payload;
        break;
      case actionTypes.IS_EXIST_CHECKLIST_ADDING_SUCCESS:
        draft.isExistChecklistItemAddSuccess = <boolean>action.payload;
        break;
      case actionTypes.IS_CHECKLIST_ITEM_REMOVING_SUCCESS:
        draft.isChecklistItemRemoveSuccess = <boolean>action.payload;
        break;
      default:
        return draft;
    }
  });
};
